import { Button, Collapse, Stack } from "@chakra-ui/react";
import React, { useState } from "react";

const PushSupportChecker = () => {
  const [results, setResults] = useState("");
  const [show, setShow] = useState<boolean>(false);

  const runChecks = () => {
    const supportsPushManager = "PushManager" in window;
    const supportsServiceWorker = "serviceWorker" in navigator;
    const supportsNotification = "Notification" in window;

    let msg = `PushManager: ${supportsPushManager}\n`;
    msg += `ServiceWorker: ${supportsServiceWorker}\n`;
    msg += `Notification: ${supportsNotification}\n`;

    setResults(msg);
    setShow(!show);
    // alert(msg); // optional: also show as popup on iPad
  };

  return (
    <Stack>
      <Button onClick={runChecks}>{show ? "Hide" : "Show"} Notification Support Checks</Button>

      <Collapse in={show} animateOpacity >
        <pre style={{ fontSize: '16px', whiteSpace: 'pre-wrap', display: 'flex', justifyContent: 'center' }}>
          {results}
        </pre>
      </Collapse>
    </Stack>
    // <div style={{ padding: '20px', alignSelf: 'center' }}>
    //   <h2>Check PWA Push Support</h2>
    //   <button
    //     onClick={runChecks}
    //     style={{ padding: '10px 20px', fontSize: '16px', backgroundColor: '#0000' }}
    //   >
    //     Run Checks
    //   </button>
    //   <pre style={{ marginTop: '20px', fontSize: '16px', whiteSpace: 'pre-wrap' }}>
    //     {results}
    //   </pre>
    // </div>
  );
};

export default PushSupportChecker;
